module.exports = __webpack_public_path__ + "static/media/post-06.68735f27.jpg";